import axios from "axios";
import { getLiftToken, clearLiftSession } from "./liftSession";

// horus-backend-lift monta sus rutas bajo "/api/v1" cuando ENVIRONMENT=devr
// (el caso local, ver horus-backend-lift/src/index.js) y bajo "/lift/api/v1"
// en dev/qa/prod (ahí el resource path lo define API Gateway). Local usa
// REACT_APP_URL_BACKEND_LIFT=http://localhost:9008 + "/api/v1".
const LIFT_API_BASE = `${process.env.REACT_APP_URL_BACKEND_LIFT}/api/v1`;

const liftClient = axios.create({ baseURL: LIFT_API_BASE });

liftClient.interceptors.request.use((config) => {
  if (!config.skipAuth) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${getLiftToken()}`;
  }
  return config;
});

liftClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearLiftSession();
      window.dispatchEvent(new Event("montacargas-force-logout"));
    }
    return Promise.reject(error);
  },
);

// Helper único para todas las peticiones de montacargas: cada llamada solo
// cambia el path, el método y el body/query; base URL, JWT y manejo de 401
// quedan resueltos acá para todo el módulo.
export function liftRequest(path, { method = "GET", body, params, skipAuth = false } = {}) {
  return liftClient
    .request({ url: path, method, data: body, params, skipAuth })
    .then((response) => response.data);
}

// Único endpoint público del módulo: no requiere JWT porque es justo el que
// lo emite.
export function loginLiftTruck({ employee_number, pin }) {
  return liftRequest("/auth/login", {
    method: "POST",
    body: { employee_number, pin },
    skipAuth: true,
  });
}

// Búsqueda de guía master, primera pantalla después del login (réplica de
// amcmontacargas-L8.8 SearchController::form).
export function searchMaster({ awb }) {
  return liftRequest("/search/form", {
    method: "POST",
    body: { awb },
  });
}
